import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Phone, Mail, MapPin } from 'lucide-react';
import { Button } from '../components/ui/button';

const PrivacyPolicy = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  const currentYear = new Date().getFullYear();

  return (
    <div className="min-h-screen bg-[#041B1C]">
      <div className="border-b border-white/10 bg-[#093336]/80 backdrop-blur-xl sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-4 flex items-center justify-between">
          <Link to="/">
            <span className="text-2xl font-bold tracking-tight text-[#F0F4F4]" style={{ fontFamily: "'Outfit', sans-serif" }}>
              TCN<span className="text-[#A5BF23]">.</span>
            </span>
          </Link>
          <Link to="/">
            <Button variant="ghost" className="text-[#A0B2B2] hover:text-[#A5BF23] hover:bg-transparent">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Home
            </Button>
          </Link>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-6 lg:px-8 py-20">
        <span className="inline-block bg-[#A5BF23]/10 text-[#A5BF23] px-4 py-1.5 rounded-full text-xs font-bold tracking-[0.2em] mb-6">LEGAL</span>
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#F0F4F4] mb-3 tracking-tight" style={{ fontFamily: "'Outfit', sans-serif" }}>
          Privacy Policy
        </h1>
        <p className="text-sm text-[#A0B2B2]/50 mb-12">Last Updated: February 2026</p>

        <div className="space-y-10">
          <section>
            <h2 className="text-lg font-bold text-[#F0F4F4] mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>1. Information We Collect</h2>
            <p className="text-sm text-[#A0B2B2] leading-relaxed">
              Trademarking Company Name collects personal information that you provide directly, including your name, email address, phone number, and details about your brand name trademark registration needs. We also collect usage data through cookies and similar technologies.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-[#F0F4F4] mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>2. How We Use Your Information</h2>
            <p className="text-sm text-[#A0B2B2] leading-relaxed">
              We use the information we collect to provide our brand name trademark registration services, communicate with you about your case, send service updates, improve our website and services, and comply with legal obligations.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-[#F0F4F4] mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>3. Information Sharing</h2>
            <p className="text-sm text-[#A0B2B2] leading-relaxed">
              We do not sell your personal information to third parties. We may share information with trusted service providers who assist in operating our website and delivering our services, or when required by law.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-[#F0F4F4] mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>4. Data Security</h2>
            <p className="text-sm text-[#A0B2B2] leading-relaxed">
              We implement appropriate technical and organizational security measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-[#F0F4F4] mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>5. Your Rights</h2>
            <p className="text-sm text-[#A0B2B2] leading-relaxed">
              You have the right to access, correct, or delete your personal information. You may also opt out of marketing communications at any time. To exercise these rights, contact us at info@trademarkingcompanyname.com.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-[#F0F4F4] mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>6. Cookies</h2>
            <p className="text-sm text-[#A0B2B2] leading-relaxed">
              Our website uses cookies to enhance your browsing experience. You can control cookie preferences through your browser settings. Some cookies are essential for the website to function properly.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-[#F0F4F4] mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>7. Contact Us</h2>
            <p className="text-sm text-[#A0B2B2] leading-relaxed">
              For any questions about this Privacy Policy, please contact us at info@trademarkingcompanyname.com or call +1 (800) 123-4567.
            </p>
          </section>
        </div>
      </div>

      <footer className="border-t border-white/5 bg-[#041B1C]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
          <div className="flex flex-col md:flex-row justify-between items-start gap-8 mb-8">
            <div>
              <span className="text-2xl font-bold tracking-tight text-[#F0F4F4]" style={{ fontFamily: "'Outfit', sans-serif" }}>TCN<span className="text-[#A5BF23]">.</span></span>
              <p className="text-xs text-[#A0B2B2]/40 mt-2 max-w-xs">Expert brand name trademark registration and federal protection nationwide.</p>
            </div>
            <div className="flex flex-col sm:flex-row gap-6 text-sm text-[#A0B2B2]/50">
              <div className="flex items-center gap-2"><Phone className="w-3.5 h-3.5 text-[#A5BF23]" strokeWidth={1.5} /><a href="tel:+18001234567" className="hover:text-[#F0F4F4] transition-colors">+1 (800) 123-4567</a></div>
              <div className="flex items-center gap-2"><Mail className="w-3.5 h-3.5 text-[#A5BF23]" strokeWidth={1.5} /><a href="mailto:info@trademarkingcompanyname.com" className="hover:text-[#F0F4F4] transition-colors">info@trademarkingcompanyname.com</a></div>
              <div className="flex items-center gap-2"><MapPin className="w-3.5 h-3.5 text-[#A5BF23]" strokeWidth={1.5} /><span>11040 Santa Monica Blvd #310, LA</span></div>
            </div>
          </div>
          <div className="border-t border-white/5 pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-xs text-[#A0B2B2]/30">&copy; {currentYear} Trademarking Company Name. All rights reserved.</p>
            <div className="flex gap-6 text-xs">
              <Link to="/privacy-policy" className="text-[#A5BF23]/60">Privacy Policy</Link>
              <Link to="/terms-conditions" className="text-[#A0B2B2]/30 hover:text-[#A5BF23] transition-colors">Terms & Conditions</Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default PrivacyPolicy;
